<template>
    <div class="publicViewClass"  id="publicWaterMark">
         <div class="preview-content" >
                    <div class="mask" v-if="showReminder"></div>
                                        <div class="downtip" v-if="showReminder">
                            <p class="num" v-if="!qzjj">{{countDown}}</p> 
                             <el-result icon="warning" title="交卷中" subTitle="请勿刷新或进行其他操作" v-if="qzjj">

                             </el-result>
                            <p v-if="!qzjj">交卷中，请勿刷新或进行其他操作</p>
                        </div>
                                                <div class="submit-buttons flex align-cen">
                            <div class="backPage btn" v-if="indexShow!=0 && sourceData.paper.answerTimeControl !=3 && sourceData.paper.allowBackChange ==1" @click="answerPublicFn('prev')">上一题</div>
                            <div class="nextPage btn" @click="answerPublicFn('next',)" v-if="indexShow != sourceData.questionMapList.length - 1">下一题</div>
                            <div class="nextPage btn"  v-if="indexShow == sourceData.questionMapList.length - 1 || ishandPaper" @click="handPaper(1)">交卷</div>
                        </div>
             <div class="new-content-panel1"  :loading="loading"  >
                <div class="doexam-header">
                     <div class="time-tip flex align-cen">
                                <span class="icon-al-clock"></span>
                                      <div class="time-main"  v-if="sourceData.paper.answerTimeControl == 1 || sourceData.paper.answerTimeControl == 2">
                                <strong>
                                    <span>
                                        <el-statistic :value="Date.now() + 1000 * 60 * sourceData.paper.answerTimeLimit" 
                                        time-indices
                                         format="HH:mm:ss"
                                           @finish="hilarity"
                                        >
                                            </el-statistic>
                                    </span>
                                </strong>
                            </div>
                             <div class="time-main"  v-if="sourceData.paper.answerTimeControl == 3">
                                <strong>
                                    <span>
                                        <el-statistic :value="Ddtime" 
                                        time-indices
                                         format="HH:mm:ss"
                                           @finish="hilarity1"
                                           v-if="DdtimeS"
                                        >
                                            </el-statistic>
                                    </span>
                                </strong>
                            </div>
                            <div class="mft flex align-cen" @click="ismonileCard = !ismonileCard">
                                总题数：{{sourceData.questionMapList.length}}
                            </div>
                            </div>
                            <div class="time-tip1" v-if="ismonileCard">
                                  <div class="questions-lists">
                            <div class="q-list">
                                <ul>
                                    <li v-for="(item,index) in sourceData.questionMapList" 
                                     :key="index" 
                                     :class="item.isAnswer == 1 ? 'Answeral' :''"
                                     @click="answerPublicFn(index)"
                                    >{{index + 1}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="metas-footer">
                            <div class="questipn-lists-icon flex align-cne">
                                <span class="allright flex align-cen">
                                    <i></i>
                                    已做
                                </span>
                                <span class="noright flex align-cen">
                                    <i></i>
                                    未做
                                </span>
                            </div>
                        </div>
                            </div>
                </div>
                <div class="doexam-main publicScroolbar">
                   <div class="row">
                    <div class="question" v-if="questionDetailList.length" >
                        <div class="question-main-content" v-for="(item,index) in questionDetailList" :key="index">
                            <div class="ques-title flex">
                                <p class="ques-number">{{indexShow + 1}}.</p>
                                <p class="ques-type">[{{$util.getTopicType(item.type)}}]</p>
                                  <p class="ques-score mft">（{{item.score}}分）</p>
                            </div>
                            <div class="quese-ti flex">
                                   <p class="title-pre" v-html="item.title" :class="item.type == 9 ? 'clozeClass' : ''">
                                    <div class="clozeMask ques-answers" v-if="item.type == 9 && isCloze">
                                        <span class="icon-al-times-circle-fill clozecloze" @click.stop="isCloze = false"></span>
                                           <ul>
                                        <li  v-for="(sonitem,sonIndex) in item.answerList[clozeIndex1].clozeList" :key="sonIndex" 
                                        :class="getClass1(item,sonIndex)"
                                        @change="showChage(sonitem,sonIndex,item.type)"
                                        >
                                           <el-radio v-model="radio1" :label="sonIndex"
                                    class="flex align-cen"
                                     >
                                     <div class="flex align-cen">
                                        {{Eng[sonIndex]}}.<div v-html="sonitem.content"></div>
                                     </div>
                                     </el-radio> 
                                        </li>

                                    </ul>
                                    </div>
                                </p>
                                <AudioTem :audioSrc="item.audio" v-if="item.audio"></AudioTem>
                            </div>
                     <div class="ques-answers">
                            <ul v-if="item.type != 5 && item.type !=7 && item.type !=9">
                                <li v-for="(sonitem,sonIndex) in item.answerList" :key="sonIndex" 
                                :class="getClass(item,sonIndex,sonitem)"
                                >
                                     <el-radio v-model="radio" :label="sonIndex"
                                    @change="showChage(sonitem,sonIndex,item.type)"
                                    class="flex align-cen"
                                    v-if="item.type == 1 || item.type ==3"
                                     >
                                     <div class="flex align-cen">
                                        {{Eng[sonIndex]}}. <div v-html="sonitem.content"></div>
                                     </div>
                                     </el-radio>   
                                      <el-checkbox-group v-model="checkList" v-if="item.type == 2 || item.type == 6"
                                       @change="showChage(sonitem,sonIndex,item.type)"
                                      >
                                        <el-checkbox :label="Eng[sonIndex]" > <div class="flex align-cen">{{Eng[sonIndex]}}.<div v-html="sonitem.content"></div></div></el-checkbox>
                                    </el-checkbox-group>
                                    <div class="ipt-group flex align-cen" v-if="item.type == 4">
                                        <span>{{sonIndex + 1}}</span>
                                        <el-input  placeholder="填写答案" v-model="sonitem.inputContent" clearable @input="showChage(sonitem,sonIndex,item.type)">
                                        </el-input>
                                    </div>
                                </li>
                            </ul>
                            <div class="essayTxr" v-if="item.type == 5">
                                <el-input
                                    type="textarea"
                                    :rows="8"
                                    placeholder="请在这里输入答案"
                                    v-model="item.answerContent"
                                    @input="showChage(item,index,item.type)"
                                    show-word-limit
                                    maxlength="10000"
                                    >
                                    </el-input>
                            </div>
                             <div class="essayPx" v-if="item.type == 7">
                                   <div class="sortingquestion-option-container" id="sortAnswers">
                                    <div class="el__row"  v-for="(sonitem,sonIndex) in emptyList3Copy" :key="`sortAnswers${sonIndex}`">
                                    <div class="sortingquestion-option flex align-cen">
                                        <div class="sortingquestion-option-move">
                                        <span class="icon-al-menu handle_move"></span>
                                        </div>
                                        <div class="sortingquestion-option-text">
                                            <div class="title-pre">{{sonitem.content}}</div>
                                        </div>
                                    </div>
                                    </div>
                                 </div>
                             </div>
                              <div class="essayWx" v-if="item.type == 9">
                                <div class="ques-tips" style="font-size:16px;color:#aaa">(点击题目空格处，选择合适的答案完成作答)</div>
                              </div>
                        </div> 
                        </div>
                    </div>
                   </div>
                </div> 
                <!-- <div class="exam-metas">
                    <div class="student-info">
                        <img :src="userinfo.avatar || require('../../assets/images/head.png')" alt="">
                        <ul class="check-info">
                            <li>
                                <span>姓名：</span>
                                 <span>{{userinfo.name}}</span>
                            </li>
                             <li>
                                <span>用户账号：</span>
                                 <span>{{userinfo.username}}</span>
                            </li>
                            <li>
                                <span>用户ID：</span>
                                 <span>{{userinfo.id}}</span>
                            </li>
                        </ul>
                    </div>
                </div> -->
             </div>
         </div>
    </div>
</template>
<script>
import WaterMark from '@/utils/waterMark.js'
import mycomponents from "@/utils/compoments.js";
import Sortable from "sortablejs";
export default {
    name:'daExam',
     components: {
         AudioTem: mycomponents.components.PublicAudio
    },
    data () {
        return {
            ismonileCard:false,
            radio1:null,
            isCloze:false,
            clozeIndex:0,
            clozeIndex1:0,
            clozeList:[],
             sortable:null,
            emptyList3Copy:[],
            emptyList3:[],
            wordCount:0,
            confirmInstance:false,
            waterMark:null,
            countDown1:'',
            qzjj:false,
            indices:[],
            encryptQuery:'',
            transcript:'',
            DdtimeS:false,
            Ddtime:'',
            userinfo:{},
            contentda:[],
            resultQuestions:[],
            answerContent:'',
            EngIndex:'',
            resultId:'',
            ishandPaper:false,
            loading:false,
            token:'',
            businessInfo:{},
            propList:{},
             inputArr:[],
            checkList:[],
             deadline:'',
        showReminder:false,
            loading:false,
            psw:'',
            account:'',
            indextype:'',
            isShow:1,
            ExamPreviewInfo:{},
             indexShow:'',
            tes:[],
            deadline2: Date.now() + 1000 * 60 * 30,
            radio:'-1',
            wsUrl: "",//定义socket连接地址
            sourceData:{},
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            questionDetailList:[],
             countDown: '', // 倒计时时间
            timer: null, // 定时器
            timer1: null // 定时器
        }
    },
    created() {
        this.stopF5Refresh();
         if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
        this.token = this.$locaStorage.setAge().get('token2')
        this.userinfo = this.$locaStorage.setAge().get('userinfo2')
         let decryptQuery=this.$base64.decode(this.$route.query.json); // 解密
        this.propList = JSON.parse(decryptQuery)
           this.webSocketData('');
           this.indexShow = 0
    },
    mounted () {
        let that = this
       window.onbeforeunload = e => {
            e = e || window.event
            if (e) {
                e.returnValue = '关闭提示'
            }
           return '关闭提示'
        }
    // 监听离开首页隐藏水印
    window.addEventListener("beforeunload", this.hidden);
    },
            //离开页面关闭socket
 destroyed() {
    window.onbeforeunload = null
     //在离开此页面的时候主动关闭socket
         this.$socketApi.closeWebsocket()
        clearInterval(this.timer);
        clearInterval(this.timer1);
        this.hidden()
  },
  methods: {
      // 设置水印
    showMark() {
      this.waterMark = new WaterMark({
        watermark_txt: '和隆优化', // 水印的内容
        watermark_x: 0, // 水印起始位置x轴坐标
        watermark_y: 0, // 水印起始位置Y轴坐标
        watermark_rows: 0, // 水印行数
        watermark_cols: 0, // 水印列数
        watermark_x_space: 50, // 水印x轴间隔
        watermark_y_space: 250, // 水印y轴间隔
        watermark_width: 350, // 水印宽度
        watermark_height: 50, // 水印长度
        watermark_angle: 35, // 水印倾斜度数
        monitor: false,
      });
    },
    // 隐藏水印
    hidden() {
      if (this.waterMark) {
        this.waterMark.remove()
      }
    },
      getClass1(data,index){
        if(this.radio1 == index) {
                return 'liActive'
            }
      },
    // 动态添加class
    getClass(data,index,item){
        if(data.type == 1 || data.type == 3){
            if(this.radio == index) {
                return 'liActive'
            }
        }else if(data.type == 2){
            if(this.indices[index] == index){
                return 'liActive'
            }
        }else if(data.type == 4){
            if(item.inputContent){
                return 'liActive'
            }
        }
    },
    stopF5Refresh() {
      document.onkeydown = function (e) {
        var evt = window.event || e;
        var code = evt.keyCode || evt.which;
        //屏蔽F1---F12
        if (code > 111 && code < 124) {
          if (evt.preventDefault) {
            evt.preventDefault();
          } else {
            evt.keyCode = 0;
            evt.returnValue = false;
          }
        }
      };
      //禁止鼠标右键菜单
      document.oncontextmenu = function () {
        return false;
      };
      //阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
      history.pushState(null, null, window.location.href);
      window.addEventListener("popstate", function () {
        history.pushState(null, null, window.location.href);
      });
    },

beforeunloadHandler(e) {
      e = e || window.event;
      if (e) {
        e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
      }
      return "您是否确认离开此页面-您输入的数据可能不会被保存";
    },
       // 交卷
        handPaper(isHave){
            this.transcript = isHave
            let params = {
                type:'submit',
                resultId:this.resultId
            }
           if(this.indexShow == this.sourceData.questionMapList.length - 1){
                   let params1 = {
                        type:'answer',
                        resultQuestions:this.resultQuestions,
                        resultId:this.resultId
                    }
                    this.$socketApi.onWsOpen(params1)
               }
            if(this.sourceData.paper.answerTimeControl != 3){
            // 时间为独立或者动态时间
            if( this.sourceData.paper.mandatory.includes('1') && isHave){
            // 必须回答完所有试题交卷
            let arr = this.sourceData.questionMapList
            let nullLen = []
            for (const key in arr) {
              if(arr[key].isAnswer == 0){
              nullLen.push(arr[key])
              }
            }
            if(nullLen.length){
                return this.$util.Notifi(`还有${nullLen.length}道题未做，请先做完试题`,'error','fa-exclamation-circle');
            }
            }
            }
            if(isHave){
                this.confirmInstance = true
           this.$confirm('您确认现在交卷吗?', '温馨提示', {
                confirmButtonText: '确认交卷',
                cancelButtonText: '再检查一下',
                type: 'warning'
            }).then(() => {
                this.confirmInstance = false
                this.$socketApi.onWsOpen(params)
                // this.startCountDown1()
            }).catch(() => {this.confirmInstance = false}); 
        }else{
            this.$socketApi.onWsOpen(params)
            // this.startCountDown1()
        }
        },
         // 倒计时结束
        hilarity(){
        if(this.confirmInstance){
            this.$msgbox.close()
        }
        this.$notify.error({
          title: "温馨提示",
          message: "时间已到，交卷中，请勿刷新页面",
          duration: 2000,
        });
        this.handPaper()
        },
          // 倒计时结束
        hilarity1(){
        this.DdtimeS = false
        if(this.indexShow == this.sourceData.questionMapList.length - 1){
            if(this.confirmInstance){
            this.$msgbox.close()
        }
        this.$notify.error({
          title: "温馨提示",
          message: "时间已到",
          duration: 1000,
        });
            // 交卷
            this.handPaper()
        }else{
           this.indexShow = this.indexShow + 1
         this.Ddtime = Date.now() + 1000 * 60 * this.sourceData.paper.singleDuration
           this.resultQuestions = []
            this.questionDetailList = []
            this.radio = '-1'
            this.checkList = []
            this.inputArr = []
            this.indices = []
             let params = {
                type:'questionDetail',
                questionIds:this.sourceData.questionMapList[this.indexShow].questionId.split(','),
                resultId:this.resultId
            }
            this.$socketApi.onWsOpen(params) 
        }
        // this.$notify.error({
        //   title: "温馨提示",
        //   message: "时间已到，交卷中，请勿刷新页面",
        //   duration: 2000,
        // });
        },
             showChage(data,index,type){
            this.indextype = type
            if(type == 9){
                this.clozeList[this.clozeIndex1] = this.Eng[index]
                 this.resultQuestions = [
                {
                 questionId:this.questionDetailList[this.clozeIndex].questionId,
                 answerContent:this.clozeList.join(',')
                }
               ]
                 // 找到所有带 clickable 类的 span 元素，并为它们添加点击事件监听器  
            let  clickableSpans1 = this.$el.querySelectorAll('.clickable');  
                    clickableSpans1[this.clozeIndex1].innerHTML = `<span style="color: #36aafd;text-decoration: #36aafd underline">${data.content}</span>`;
                    }
            else if(type == 5){ 
                this.resultQuestions = [
                {
                   questionId:data.questionId,
                 answerContent:data.answerContent
                }
               ]
            }else if( type == 4){
                  let a = this.questionDetailList
                    let ar
                 for (const key in a) {
                    this.inputArr = a[key].answerList
                  if(a[key].answerList.every(item => !item.inputContent)){
                     this.sourceData.questionMapList[this.indexShow].isAnswer = 0
                  }else{
                     this.sourceData.questionMapList[this.indexShow].isAnswer = 1
                     const contentArray =  this.inputArr.map(item => item.inputContent);
                   this.resultQuestions = [
                {
                   questionId:data.questionId,
                  answerContent:contentArray.join(',')
                }
               ]
                  }
                 
                }
            }else if( type == 2 || type == 6){
               this.indices = this.checkList.map((item, index) => this.Eng.indexOf(item));
                if(!this.checkList.length){
                     this.sourceData.questionMapList[this.indexShow].isAnswer = 0
                }else{
                  this.sourceData.questionMapList[this.indexShow].isAnswer = 1                    
                this.resultQuestions = [
                {
                   questionId:data.questionId,
                 answerContent:this.checkList.join(',')
                }
               ]
                }
            }else{
                 this.sourceData.questionMapList[this.indexShow].isAnswer = 1
               this.resultQuestions = [
                {
                   questionId:data.questionId,
                 answerContent:this.Eng[index] 
                }
               ]
            }
        },
            // 下一题
        answerPublicFn(type){
            this.loading = true
            this.isCloze = false
            if(type == 'next'){
             if(this.resultQuestions.length){
                let params1 = {
                type:'answer',
                resultQuestions:this.resultQuestions,
                resultId:this.resultId
            }
           this.$socketApi.onWsOpen(params1)
             }
            this.indexShow = this.indexShow + 1
            if(this.sourceData.paper.answerTimeControl == 3){
                this.DdtimeS = false
                this.Ddtime = Date.now() + 1000 * 60 * this.sourceData.paper.singleDuration
            }
            }else if(type == 'prev'){
                this.indexShow = this.indexShow - 1
                if(this.indexShow < 0){
                    this.indexShow = 0 
                }
            }else{
                if(this.sourceData.paper.answerTimeControl !=3){
                    if(this.sourceData.paper.allowBackChange){
                                    if(this.resultQuestions.length){
                let params2 = {
                type:'answer',
                resultQuestions:this.resultQuestions,
                resultId:this.resultId
            }
           this.$socketApi.onWsOpen(params2)
             }
                this.indexShow = type 
                    }else{
                          return
                    }
                }else{
                  
                }
            }
            this.resultQuestions = []
            this.questionDetailList = []
            this.radio = '-1'
            this.checkList = []
            this.inputArr = []
             this.indices = []
             let params = {
                type:'questionDetail',
                questionIds:this.sourceData.questionMapList[this.indexShow].questionId.split(','),
                resultId:this.resultId
            }
            this.$socketApi.onWsOpen(params)
        }, 
               webSocketData(questionId){
            this.loading = true
            let socketUrl = ''
            if(this.$config.baseUrl.includes('http://')){
                 socketUrl = this.$config.baseUrl.replace('http://', 'ws://'); 
            }else{
                 socketUrl = this.$config.baseUrl.replace('https://', 'wss://'); 
            }
            let wsUrl = `${socketUrl}/exam/ws/${this.propList.id}?token=${this.token}&businessId=${this.businessInfo.id}&view=start`
            console.log(wsUrl)
            let params = {
                type:'questionDetail',
                questionIds:[],
                resultId:this.resultId
            }
            this.$socketApi.connectWebsocket(wsUrl,params,(res) => {
                    let datas = JSON.parse(res) 
                    this.loading = false
                  if(datas.code == 0 ){
                    if(datas.data.paper){
                          this.sourceData = datas.data
                        document.title = this.sourceData.paper.paperName
                          if(this.sourceData.paper.watermark == 1){
                             this.showMark()
                          }
                        //   为独立时间时
                          if(datas.data.paper.answerTimeControl == 1 || datas.data.paper.answerTimeControl == 2){
                              this.deadline = Date.now() + 1000 * 60 * datas.data.paper.answerTimeLimit
                          this.countDown = Number((datas.data.paper.answerTimeLimit * 60) - 1)
                           this.startCountDown()
                          }
                        //   查找未答题索引
                        let firstZeroIndex 
                        if(datas.data.questionMapList.findIndex(item => item.isAnswer == 0) == -1){
                            firstZeroIndex = 0
                        }else{
                            firstZeroIndex = datas.data.questionMapList.findIndex(item => item.isAnswer == 0);
                        }
                          this.indexShow = firstZeroIndex
                          if(!this.sourceData.paper.allowBackChange){
                             this.$util.Notifi('此试卷已设置不允许返回修改答案，请您认真回答提交每一题','error','fa-exclamation-circle') 
                          }
                          params.questionIds = []
                          params.questionIds.push(datas.data.questionMapList[firstZeroIndex].questionId)     
                          params.resultId = datas.data.resultId
                          this.resultId = datas.data.resultId
                          this.$socketApi.onWsOpen(params)
                    }else if(datas.data.questionDetailList){
                        if(this.sourceData.paper.answerTimeControl == 3){
                            this.DdtimeS = true
                            this.Ddtime = Date.now() + 1000 * 60 * this.sourceData.paper.singleDuration
                        }
                        this.questionDetailList = datas.data.questionDetailList
                        this.sourceData.questionMapList = datas.data.questionMapList
                        for (const indexK in this.questionDetailList) {
                              if(this.questionDetailList[indexK].answerContent){
                                this.resultQuestions = [
                                            {
                                            questionId:this.questionDetailList[indexK].questionId,
                                            answerContent:this.questionDetailList[indexK].answerContent
                                            }
                                    ]
                                }
                            if(this.questionDetailList[indexK].type == 1 || this.questionDetailList[indexK].type == 3){
                                if(this.Eng.indexOf(this.questionDetailList[indexK].answerContent)){
                                    this.radio = this.Eng.indexOf(this.questionDetailList[indexK].answerContent)
                                }else if(this.Eng.indexOf(this.questionDetailList[indexK].answerContent) == 0){
                                    this.radio = 0 
                                }else{
                                    this.radio = '-1'
                                }
                            }else if(this.questionDetailList[indexK].type == 2 || this.questionDetailList[indexK].type == 6){
                               this.checkList = this.questionDetailList[indexK].answerContent ? this.questionDetailList[indexK].answerContent.split(',') : []
                                if(this.checkList.length){
                                    this.indices = this.checkList.map((item, index) => this.Eng.indexOf(item));
                                }
                            }else if(this.questionDetailList[indexK].type == 4){
                                // 使用map方法为每个问题赋值  
                                let anwerDa =  this.questionDetailList[indexK].answerContent ? this.questionDetailList[indexK].answerContent.split(',') : []
                                 for (let q in this.questionDetailList[indexK].answerList) {
                                    this.$set(this.questionDetailList[indexK].answerList[q], 'inputContent', '')
                                }
                                if(anwerDa.length){
                                    let questions = this.questionDetailList[indexK].answerList
                                  questions = questions.map((question, index) => {  
                                    question.inputContent = anwerDa[index];  
                                    return question;  
                                });
                                
                                }
                                
                            }else if(this.questionDetailList[indexK].type == 7){
                                this.emptyList3 = this.questionDetailList[indexK].answerList
                                let a = this.questionDetailList[indexK].answerList
                                let b = []
                                let c = []
                                if(this.questionDetailList[indexK].answerContent){
                                    b = this.questionDetailList[indexK].answerContent.split(',')
                                    let indices = b.map(element => {  
                                        return this.Eng.indexOf(element);  
                                    }); 
                                  indices.forEach(index => {  
                                    // 确保索引在a数组的有效范围内  
                                        if (index >= 0 && index < a.length) {  
                                            c.push(a[index]);  
                                        }  
                                    });
                                    this.emptyList3Copy = [...c]
                                }else{
                                    this.emptyList3Copy = [...this.questionDetailList[indexK].answerList]
                                }
                               
                             this.$nextTick(() => {
                                    this.init()
                                })
                            }else if(this.questionDetailList[indexK].type == 9){
                             this.clozeList = this.questionDetailList[indexK].answerContent ? this.questionDetailList[indexK].answerContent.split(',') : []  
                            this.questionDetailList[indexK].answerList.forEach((t,index) => {
                                let patternString = `{{${index + 1}}}`;
                                this.questionDetailList[indexK].title = this.questionDetailList[indexK].title.replace(patternString, `<span class="clickable" data_type="${indexK}" data_type2="${index}" style="color: rgb(54, 170, 253);cursor: pointer;">______</span>`)
                                     this.$nextTick(() => {
                                      if(this.clozeList.length){
                                          let a = this.questionDetailList[indexK].answerList[index].clozeList
                                       let  clickableSpans1 = this.$el.querySelectorAll('.clickable');  
                                        let arrindex = this.Eng.indexOf(this.clozeList[index]);
                                         clickableSpans1[index].innerHTML = `<span style="color: #36aafd;text-decoration: #36aafd underline">${a[arrindex].content}</span>`;
                                      }
                                  this.addClickableListeners(); 
                                })
                                  
                            })  
                            }
                        }
                    }else if(datas.data.answerTime){
                        let params = {
                            dataJson:datas.data,
                        }
                         this.encryptQuery = this.$base64.encode(JSON.stringify(params)) //链接参数加密
                         if(this.encryptQuery ){
                          this.showReminder = false
                         this.qzjj = false
                              this.$router.push({
                                name:'transcriptExam',
                                query:{
                                    id:this.propList.id,
                                    examJons:this.encryptQuery,
                                    transcript:this.transcript,
                                    resultId:this.resultId
                                }
                        })
                         }
                    }
                  }else{
                    if(datas.code == 200){
                        // 强制交卷
                        this.$util.Notifi(datas.msg,'error','fa-exclamation-circle')
                        if(datas.data.answerTime){
                        let params = {
                            dataJson:datas.data,
                        }
                         this.encryptQuery = this.$base64.encode(JSON.stringify(params)) //链接参数加密
                          if(this.encryptQuery ){
                          this.showReminder = false
                         this.qzjj = false
                              this.$router.push({
                                name:'transcriptExam',
                                query:{
                                    id:this.propList.id,
                                    examJons:this.encryptQuery,
                                    transcript:this.transcript,
                                    resultId:this.resultId
                                }
                        })
                         }
                    }
                    }else if(datas.code == 424){
                        // 被人强挤登录
                        this.$util.Notifi(datas.msg,'error','fa-exclamation-circle')
                          setTimeout(() => {
					    this.$router.push('/myExam/testingCenter')
                        },1000);
                    }else{
                        this.$util.Notifi(datas.msg,'error','fa-exclamation-circle') 
                        if(datas.msg.includes('已经交卷')){
                             setTimeout(() => {
					    this.$router.push('/myExam/testingCenter')
                        },1000);
                        }else if(datas.msg.includes('权限')){
                             setTimeout(() => {
					    this.$router.push('/myExam/testingCenter')
                        },1000);
                        }else{
                          this.showReminder = false
                         this.qzjj = false
                         this.countDown1 = '' 
                        clearInterval(this.timer1);
                        }
                    }
                  }
                    },
                    () => {
                        this.loading = false
                        console.log("失败的回调函数");
                    }
                    );
        },
                         	init(){                               
                                // console.log(this.emptyList3Copy)
		// 1. 获取拖拽元素的父元素
		// 因为使用的element的table 所以可直接获取tbody
		let el =  document.getElementById("sortAnswers");
		let that = this;	
		// 2. 创建并配置相关参数
		 this.sortable = new Sortable(el, {			
			// 只有按住手柄才能进行拖拽
            handle:'.handle_move',
			// 行拖拽，所以该值设置为行class            
			// 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
      draggable:'.el__row', // 允许拖拽的项目类名	
		// 拖拽结束，调整位置
			onEnd(event) {
              let oldIndex = event.oldIndex;
                let newIndex = event.newIndex;  
                 let temp = that.emptyList3Copy[oldIndex];
                 if(oldIndex < newIndex){
                      for(var i = oldIndex ; i < newIndex ; i++){
                        that.emptyList3Copy[i] = that.emptyList3Copy[i+1];
                    }
              }
              if(oldIndex > newIndex){
                for(var i = oldIndex ; i > newIndex ; i--){
                        that.emptyList3Copy[i] = that.emptyList3Copy[i-1];
                    }
              }
             
              that.emptyList3Copy[newIndex] = temp;    
             let b = that.emptyList3Copy
              let a = that.emptyList3
             // 创建一个空数组来存储b中每个对象在a中的索引  
            let indices = b.map(objB => {  
                // 使用findIndex找到objB在a中的索引，基于isRight属性相等  
                return a.findIndex(objA => objA.isRight === objB.isRight);  
            });
                    let result =  indices.map(index => that.Eng[index]);
                      that.resultQuestions = [
                        {
                            questionId: that.emptyList3Copy[newIndex].questionId,
                            answerContent:result.join(',')
                        }
                        ]            
	        },
		})
	},   
  addClickableListeners() {  
      // 找到所有带 clickable 类的 span 元素，并为它们添加点击事件监听器  
      const clickableSpans = this.$el.querySelectorAll('.clickable');  
      clickableSpans.forEach((span) => {  
        span.addEventListener('click', (event) => {  
          // 获取自定义属性的值  
          const dataType = span.getAttribute('data_type');  
          const dataType2 = span.getAttribute('data_type2');  
          // 调用 Vue 方法处理点击事件  
          this.openRa(dataType, dataType2);  
        });  
      });  
    },
    // 
    openRa(index1,index2){
         console.log(index1,index2)
        if(this.clozeList[index2]){
            let str = this.clozeList[index2]
            let arrindex = this.Eng.indexOf(str);
            this.radio1 = arrindex
        }else{
             this.radio1 = '-1'
        }  
        this.clozeIndex = index1
        this.clozeIndex1 = index2
        this.isCloze = true
    },
                   startCountDown() {
                        this.timer = setInterval(() => {
                        if (this.countDown > 0) {
                        this.countDown--;
                        if(this.countDown == 5){
                            this.showReminder = true
                        }
                        } else {
                        this.showReminder = false
                       clearInterval(this.timer);
                        this.$router.push({
                                name:'transcriptExam',
                                query:{
                                    id:this.propList.id,
                                    examJons:this.encryptQuery,
                                    transcript:this.transcript,
                                    resultId:this.resultId
                                }
                        })
                        }
                        }, 1000);
                        },
                          startCountDown1() {
                            this.countDown1  = 5
                            this.qzjj = true
                            this.showReminder = true
                        this.timer1 = setInterval(() => {
                        if (this.countDown1 > 0) {
                        this.countDown1--;
                        } else {
                        this.countDown1 = ''
                       this.$router.push({
                                name:'transcriptExam',
                                query:{
                                    id:this.propList.id,
                                    transcript:this.transcript,
                                    resultId:this.resultId
                                }
                        })
                        clearInterval(this.timer1);
                        }
                        }, 1000);
                        }
  },
}
</script>
<style lang="scss" scoped>
   .clozeMask{
        position: absolute;
        background: #fff;
        left: 50px;
        top: 50px;
        min-width: 200px;
        box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
        background: #fff;
        padding: 20px;
        border: 1px solid #eee;
        border-radius: 5px;
        .clozecloze{
                display: block;
                position: absolute;
                right: 5px;
                top: -2px;
                cursor: pointer;
        }
       }
  .sortingquestion-option-container{
    .el__row{
      margin-bottom: 20px;
      .sortingquestion-option{
        position: relative;
       .sortingquestion-option-move{
        text-align: center;
            width: 36px;
            height: 36px;
            background-color: #f3f3f3;
           
            border: solid 1px #ccc;
            cursor: grab;
            line-height: 34px;
            box-sizing: border-box;
            span{
              font-size: 18px;
              color: #999;
              vertical-align: middle;
              transform: translateY(50%);
            }
       }
       .sortingquestion-option-text{
        width: 80%;
       }
    
        .title-pre{
                position: relative;
    height: 36px;
    line-height: 36px;
    border: 1px solid #e5e3e2;
    border-left: none;
    background: #fff;
    padding-left: 30px;
    box-sizing: border-box;
        }
       .edit-btn-group{
        font-size: 18px;
        color: red;
        margin-left: 30px;
        margin-right: 30px;
        cursor: pointer;
       }
      }
    }
  }
.publicViewClass{
    width: 100%;
    height: calc(100vh - 56px);
    overflow: hidden;
    padding-top: 0;
}
.mask{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.6);
    top: 0;
    left: 0;
    z-index: 1;
}
.preview-content{
    .downtip{
    position: absolute;
     z-index: 9999;
    width: 350px;
    height: 250px;
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    text-align: center;
    .num{
        color: red;
        font-size: 34px;
        padding-top: 60px;
        padding-bottom: 10px;
    }
}
   .new-content-panel1{
    margin-right: auto;
    margin-left: auto;
    border-radius: 5px;
    position: absolute;
    padding-bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    .doexam-header{
        height: 5px;
        margin-top: -10px;
    margin-left: -15px;
    position: fixed;
    width: 100%;
    height: 50px;
    top: 20px;
    left: 15px;
    z-index: 3;
    .time-tip{
        background: #fff;
        height: 50px;
        padding: 0 15px;
        .icon-al-clock{
            color: #36aafd;
            font-size: 20px;
        }
    }
    .time-tip1{
        background: #fff;
        padding: 0 15px;
            .questions-lists{
     max-height: 290px;
    overflow-y: auto;
    margin-bottom: 10px;
    padding-right: 0; 
    padding: 10px;
    .q-list{
      ul{
           display: flex;
            flex-wrap: wrap;
        li{
           font-size: 12px;
    display: block;
    padding: 2px 5px;
    border: 1px solid #bbb;
    border-radius: 2px;
    margin-right: 9px;
    margin-bottom: 9px;
    min-width: 25px;
    color: #666;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
        }
        .Answeral{
            background: #36aafd;
            color: #fff;
            border: none;
        }
        li:hover{
            background: #36aafd;
            color: #fff;
            border: none;
        }
      }
    }
    }
            .metas-footer{
        margin-top: 20px;
    .questipn-lists-icon{
        justify-content: center;
        span{
            margin-bottom: 10px;
            color: #aaa;
            margin-right: 10px;
        }
                   .allright{
              i{
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 5px;
                background: #36aafd;
               margin-right: 5px;
              }
            }
            .noright{
                i{
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 5px;
               border: 1px solid #aaa;
               box-sizing: border-box;
                margin-right: 5px;
                }
            }
    }
    }
    }
    }
    // .exam-metas{
    //     width: 100%;
    //         background: #fff;
    //         flex-shrink: 0;
    //         .student-info{
    //             text-align: center;
    //             padding-top: 10px;
    //           img{
    //              width:100px;height:100px;border-radius: 50%;
    //           }
    //           .check-info{
    //             padding: 30px 0px 0 0px;
    //             li{
    //                 display: block;
    //                 overflow: hidden;
    //                 list-style: none;
    //                 margin: 5px 0;
    //                 span{
    //                     margin-bottom: 15px;
    //                     font-size: 12px;
    //                     color: #333;
    //                 }
    //             }
    //           }
    //         }
    //     .metas{
    // position: relative;
    // padding: 0 10px;
    // background-color: #fff;
    // margin-bottom: 13px;
    // text-align: center;
    // height: 100%;
    // .metas-p{
    //  padding-top: 11px;
    // overflow: hidden;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
    // white-space: normal;
    // }
    // .time-left{
    //    margin: 21px 0 10px;
    //    border-top: 1px solid #e6e6e6;
    //     border-bottom: 1px solid #e6e6e6;
    //    .time-main{
    //     margin-top: 11px;
    //     span{
    //        font-size: 34px;
    //         color: #36aafd;
    //         font-weight: 400; 
    //     }
    //    }
    //    .time-tip{
    //     color: #666;
    //     font-size: 16px;
    //     justify-content: center;
    // span{
    //     color: #36aafd;
    //     font-size: 20px;
    // }
    //    }
    //    .page{
    //         margin: 25px 0;
    // font-size: 16px;
    // color: #333;
    // padding: 5px 0;
    //    }
    // }
    // .questions-card{
    // font-size: 14px;
    // margin-top: 20px;
    // margin-bottom: 5px;
    // }
    // .questions-lists{
    //  max-height: 290px;
    // overflow-y: auto;
    // margin-bottom: 10px;
    // padding-right: 0; 
    // padding: 10px;
    // .q-list{
    //   ul{
    //        display: flex;
    //         flex-wrap: wrap;
    //     li{
    //        font-size: 12px;
    // display: block;
    // padding: 2px 0;
    // border: 1px solid #bbb;
    // border-radius: 2px;
    // margin-right: 9px;
    // margin-bottom: 9px;
    // min-width: 25px;
    // color: #666;
    // position: relative;
    // cursor: pointer;
    // box-sizing: border-box;
    //     }
    //     .Answeral{
    //         background: #36aafd;
    //         color: #fff;
    //         border: none;
    //     }
    //     li:hover{
    //         background: #36aafd;
    //         color: #fff;
    //         border: none;
    //     }
    //   }
    // }
    // }
    // .metas-footer{
    //     margin-top: 20px;
    // .questipn-lists-icon{
    //     justify-content: center;
    //     span{
    //         margin-bottom: 10px;
    //         color: #aaa;
    //         margin-right: 10px;
    //     }
    //                .allright{
    //           i{
    //             display: block;
    //             width: 16px;
    //             height: 16px;
    //             border-radius: 5px;
    //             background: #36aafd;
    //            margin-right: 5px;
    //           }
    //         }
    //         .noright{
    //             i{
    //             display: block;
    //             width: 16px;
    //             height: 16px;
    //             border-radius: 5px;
    //            border: 1px solid #aaa;
    //            box-sizing: border-box;
    //             margin-right: 5px;
    //             }
    //         }
    // }
    // }
    //     }
    // }
    .doexam-main{ 
    background-color: #fff;
    margin: 0 15px;
    flex-grow: 1;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 100px;
    min-height: 400px;
    .question{
        padding: 0 15px;
        position: relative;
        .question-main-content{
            margin-top: 15px;
         margin-bottom: 15px;
         .ques-title{
            font-size: 16px;
            line-height: 30px;
            hyphens: auto;
            -ms-hyphens: auto;
            text-align: justify;
            .ques-number{
                line-height: 27px;
                color: #36aafd;
                border-color: #36aafd;
                padding-top: 2px;
                margin-right: 3px;
            }
           .ques-type{
                 margin-right: 10px;
                vertical-align: middle;
                color: #36aafd;
                }
                                .title-pre{
                    white-space: normal!important;
                    max-width: 70%;
                }
                .ques-score{
                    color: #aeaeae;
                }
         }
                .ques-answers{
            margin-top: 15px;
            ul{
                li{
                    font-size: 14px;
                        white-space: normal;
                        background-color: #fff;
                        border-color: #eaeaea;
                        text-align: left;
                        margin-bottom: 10px;
                        padding: 10px 12px;
                        font-weight: 400;
                        line-height: 1.42857143;
                        white-space: nowrap;
                        vertical-align: middle; 
                        -ms-touch-action: manipulation;
                        touch-action: manipulation;
                        cursor: pointer;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        background-image: none;
                        border: 1px solid #eaeaea;
                        border-radius: 4px;
                }
                li:hover{
                    background-color: #fff;
                border-color: #009aff;
                }
                .liActive{
                  border: 2px solid #009aff;
                }
            }
         }
        }
    }
    }
    }
   }
       .submit-buttons{
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 9999;
    .btn{
    padding: 10px 0;  
    flex: 1;
        background: #fff;
        margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    }
    .backPage{
    color: #36aafd;
    }
    .nextPage{
    color: #fff;
    background-color: #36aafd;
    border: none;
    }
    }
        .submit-buttons:only-child .btn{
            flex: auto;
        }
::v-deep{
       @media (max-width: 640px){
        .ql-align-justify{
            white-space: normal !important;
            line-height: normal !important;
        }
       }
    .el-statistic{
    font-weight: 400;
    .number{
    font-size: 18px;
    color: #36aafd;
    }
    }
    .ipt-group{
        .el-input{
            width: 200px;
            .el-input__inner{
                border: none;
                border-bottom: 1px solid #DCDFE6;
                border-radius: 0;
                margin-left: 10px;
            }
        }
    }
    .clozeClass{
    p{
        display: inline-block !important;
      }
  }
    
}
</style>